export default {
  button: "Jak na to?",
  product_creation: "Jak vytvořit produkt a kolekce:",
  menu_items: "Jak upravit menu Vašeho eshopu:",
}
